import styled from "styled-components";

export const RoundButton = styled.button<{
  disabled?: boolean;
}>`
  width: 40px;
  height: 40px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(
    ${(props) => (props.disabled ? "--color-gray-3" : "--color-brand-0")}
  );
  border-radius: 50%;
  transition: all 0.3s ease;

  &:hover {
    background-color: var(
      ${(props) => (props.disabled ? "" : "--color-brand-3")}
    );
    box-shadow: 1px 2px 5px var(--color-gray-0);
    cursor: ${(props) => (props.disabled ? "default" : "")};
  }

  > img {
    width: 20px;
    height: 20px;
  }
`;
